import { useMemo } from 'react';

import { generateSvgId } from 'src/lib/svg';

/**
 * Hook that generates a unique SVG ID
 * @returns A unique SVG ID string
 */
export const useSvgId = (): string => {
  return useMemo(() => generateSvgId(), []);
};
